import { useEffect } from 'react';
import { LayoutObservable } from '@/observables/layout.observable';

export const useDisposeSideMenu = () => {
  useEffect(() => {
    LayoutObservable.toggleDisplaySideMenu(false);

    return () => LayoutObservable.toggleDisplaySideMenu(true);
  }, []);
};
